import { SHORTCUT } from '@app/ui';
import { Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CancelAppointmentChatWidget } from './CancelAppointmentChatWidget';
import { Form } from '@webinex/antik';
import { CancelAppointmentChatForm } from './CancelAppointmentChatForm';

interface CancelAppointmentChatModalWidgetProps {
  visitorId: string;
  appointmentStart: string;
  onClose: () => void;
}

export function CancelAppointmentChatModalWidget(props: CancelAppointmentChatModalWidgetProps) {
  const { visitorId, appointmentStart, onClose } = props;
  const { t } = useTranslation(undefined, { keyPrefix: 'cancelAppointmentChat' });
  const submitForm = Form.useSubmit(CancelAppointmentChatForm.uid);
  const [canSubmit, setCanSubmit] = useState(false);

  return (
    <Modal
      open
      title={t('title')}
      onCancel={onClose}
      onOk={submitForm}
      okText={t('submitButton')}
      okButtonProps={{ 'data-shortcut': SHORTCUT.save, disabled: !canSubmit }}
      cancelButtonProps={{ 'data-shortcut': SHORTCUT.close }}
    >
      <CancelAppointmentChatWidget
        visitorId={visitorId}
        appointmentStart={appointmentStart}
        onClose={onClose}
        onCanSubmitChange={setCanSubmit}
      />
    </Modal>
  );
}
